/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocsCatalogControllerContentQueryResponse, DocsCatalogControllerContentQueryParams } from "../../models/documentsController/DocsCatalogControllerContent";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { docsCatalogControllerContent } from "../../clients/documentsService/docsCatalogControllerContent";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const docsCatalogControllerContentQueryKey = (params: DocsCatalogControllerContentQueryParams) => [{
  url: '/api/v1/documents/docs/content'
}, ...(params ? [params] : [])] as const;
export type DocsCatalogControllerContentQueryKey = ReturnType<typeof docsCatalogControllerContentQueryKey>;
export function docsCatalogControllerContentQueryOptions(params: DocsCatalogControllerContentQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = docsCatalogControllerContentQueryKey(params);
  return queryOptions<DocsCatalogControllerContentQueryResponse, ResponseErrorConfig<Error>, DocsCatalogControllerContentQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return docsCatalogControllerContent(params, config);
    }
  });
}

/**
 * @summary Read one doc’s markdown by its catalog path
 * {@link /api/v1/documents/docs/content}
 */
export function useDocsCatalogControllerContent<TData = DocsCatalogControllerContentQueryResponse, TQueryData = DocsCatalogControllerContentQueryResponse, TQueryKey extends QueryKey = DocsCatalogControllerContentQueryKey>(params: DocsCatalogControllerContentQueryParams, options: {
  query?: Partial<QueryObserverOptions<DocsCatalogControllerContentQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? docsCatalogControllerContentQueryKey(params);
  const query = useQuery({
    ...docsCatalogControllerContentQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}